<div class="wrapper">
  <div class="left">
    <button class="side-action" (click)="onCancelClick()">
      <i class="fal fa-chevron-left"></i> {{ textCancel() | translate }}
    </button>
  </div>
  <div class="center">
    @for (groupAction of groupActions(); track groupAction.id) {
      <div class="group">
        @for(action of groupAction.actions; track action.name) {
          <div class="action">
            <infl-drawing-header-action
              [action]="action"
              (actionClick)="onClickAction($event)"
              (longPress)="onLongPress($event)"
            />
            @switch (action.name) {
              @case ('draw') {
                <div
                  class="selector draw-selector"
                  [ngClass]="{ displayed: focusActionName() === 'draw' }"
                >
                  <input
                    #inputDraw
                    [type]="'range'"
                    [min]="2"
                    [max]="20"
                    [defaultValue]="drawThickness()"
                    (change)="onChangeDrawThickness()"
                  />
                </div>
              }
              @case ('highlight') {
                <div
                  class="selector highlight-selector"
                  [ngClass]="{ displayed: focusActionName() === 'highlight' }"
                >
                  <input
                    #inputHighlight
                    [type]="'range'"
                    [min]="20"
                    [max]="50"
                    [defaultValue]="highlightThickness()"
                    (change)="onChangeHighlightThickness()"
                  />
                </div>
              }
              @case ('eraser') {
                <div
                  class="selector eraser-selector"
                  [ngClass]="{ displayed: focusActionName() === 'eraser' }"
                >
                  <input
                    #inputEraser
                    [type]="'range'"
                    [min]="10"
                    [max]="100"
                    [defaultValue]="eraserThickness()"
                    (change)="onChangeEraserThickness()"
                  />
                </div>
              }
              @case ('color') {
                <div
                  class="selector color-selector"
                  [ngClass]="{
                displayed: focusActionName() === 'color',
              }"
                >
                  @for (color of colors(); track color) {
                    <i
                      class="fas fa-{{ color.icon }}"
                      (click)="onClickColor(color)"
                      [style.color]="color.text"
                    ></i>
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="right">
    <button class="side-action" (click)="onSaveClick()">
      {{ textSave() | translate }}
    </button>
  </div>
</div>

<inf-dialog
  [type]="DialogType.confirm"
  [title]="'Suppression'"
  [confirmText]="{ yes: 'Supprimer', no: 'Annuler' }"
  (action)="onActionDialog($event)"
>
  En confirmant, vous supprimerez définitivement le dessin. Êtes-vous sûr de
  vouloir continuer ?
</inf-dialog>
